// The pipeline of the open page (`/p/<id>`, R-U31): the context a record made from a relation joins. Read from the address, not a
// remembered choice — there is no «chosen pipeline» any more (decision 040 п.3).

import type { Id } from '@confdeck/core-shared';
import { useLocation } from '../shell/router.ts';

export const pipelineOfPath = (path: string): Id | null => /^\/p\/([^/?#]+)/.exec(path)?.[1] ?? null;
export const usePagePipeline = (): Id | null => pipelineOfPath(useLocation().path);
